import { Log, StepApproval } from "../generic";
import { FileProps } from "../..";
import { User } from "../userTypes";

interface AssigningRecommendationCreate {
  moc_measures_completed: boolean | null;
  reassessment_comment: string | null;
  recommendation_id: number;
}

export interface CreateStep6Body {
  assigning_recommendations: AssigningRecommendationCreate[];
  mitigation_removed: boolean | null;
  mitigation_removed_comment: string;
  tag_restored: boolean | null;
  tag_restored_comment: string;
  reassessment_files: FileProps[] | undefined;
  draft: boolean;
}

export interface AssigningRecommendationStep6
  extends AssigningRecommendationCreate {
  due_date: string | Date;
  implementation_actions: string;
  recommendation: string;
  permanent_change: boolean | null;
}

export interface Step6Response extends Log {
  assigning_recommendations: AssigningRecommendationStep6[];
  cto_code: string;
  mitigation_removed: boolean | null;
  mitigation_removed_comment: string;
  reassessment_files: FileProps[] | undefined;
  tag_restored_comment: string;
  tag_restored: boolean | null;
  step_approved_by: User | null;
  step_approved_at: Date | null;
  can_user_fill_step: boolean;
  eligible_users?: string[];
  draft: boolean;
}

export enum StepToReturnNewStep6Enum {
  STEP_4 = 4,
  STEP_5 = 5,
}

export interface CreateNewStep6Body {
  should_proceed_for_closure: boolean | null;
  closure_review_comments: string;
  step_to_return: StepToReturnNewStep6Enum | null;
  approvals?: StepApproval[] | null;
  draft: boolean;
}

export interface NewStep6Response extends CreateNewStep6Body {
  cto_code: string;
  can_user_fill_step: boolean;
  eligible_users?: string[];
  ineligible_users_ids?: number[];
}

export interface NewStep6ApprovalForm {
  approved: boolean | null;
  justification: string;
  step_to_return?: StepToReturnNewStep6Enum;
}
